<template>
    <div class="wineguide-container">
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/wine-guide')" class="v-breadcrumbs__item">{{ $t("home-top4") }}</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">France</span>
            </li>
        </ul>
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <div @click="goToPrev()" class="wine-guide-back"></div>
                        {{ $t("regions") }}
                    </div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/bordeaux')">Bordeaux</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/burgundy')">Burgundy</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/champagne')">Champagne</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/cognac')">Cognac</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/jura')">Jura</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/languedoc-roussillon')">Languedoc-Roussillon</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/provence')">Provence</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/france/rhone')">Rhone</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <div @click="goToPrev()" class="wine-guide-back"></div>
                        {{ $t("regions") }}
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Francia Vini Pregiati</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La Francia ha davvero tutto. Rossi corposi di Bordeaux e Borgogna, bianchi frizzanti e fruttati di Chablis, rosati dolci della Provenza, champagne frizzanti...
                        <br/>
                        La Francia è il re indiscusso di tutti i paesi del vino. Più che uno status symbol o qualcosa da bere, il vino è uno stile di vita per i francesi. Nove dei primi dieci vini più costosi al mondo sono francesi. Quindi non sorprende che, essendo il paese che ci ha portato Lafitte, Margaux, Petrus e Cheval Blanc, i francesi sappiano una o due cose sul business del vino pregiato.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Feine Weine aus Frankreich</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Frankreich hat wirklich alles. Vollmundige Rotweine aus Bordeaux und Burgund, knackige, fruchtige Weißweine aus Chablis, süße Roséweine aus der Provence, prickelnde Champagner ...
                        <br/>
                        Frankreich ist der unangefochtene König aller Weinländer. Wein ist für die Franzosen mehr als nur ein Statussymbol oder ein Getränk, er ist eine Lebensart. Neun der zehn teuersten Weine der Welt sind französischer Herkunft. Kein Wunder also, dass die Franzosen als das Land, das uns Lafitte, Margaux, Petrus und Cheval Blanc hervorgebracht hat, ein oder zwei Dinge über das Geschäft mit edlen Weinen wissen.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Grands Vins de France</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La France a vraiment tout. Rouges corsés de Bordeaux et de Bourgogne, blancs croquants et fruités de Chablis, rosés doux de Provence, Champagnes pétillants...
                        <br/>
                        La France est le roi incontesté de tous les pays viticoles. Plus qu'un symbole de statut social ou quelque chose à boire, le vin est un mode de vie pour les Français. Neuf des dix vins les plus chers au monde sont français. Il n'est donc pas surprenant qu'en tant que pays qui nous a amené Lafitte, Margaux, Petrus et Cheval Blanc, les Français connaissent une chose ou deux sur le commerce des vins fins.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">France Fine Wines</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        France really does have it all. Full bodied reds from Bordeaux and Burgundy, crisp, fruity whites from Chablis, sweet rosés from Provence, sparkling Champagnes...
                        <br/>
                        France is the undisputed king of all wine countries. More than just a status symbol or something to drink, wine is a way of life to the French. Nine of the world’s top ten most expensive wines are French. So it comes as no surprise that as the country that brought us Lafitte, Margaux, Petrus and Cheval Blanc the French know a thing or two about the fine wine business.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "France",
    head: {
        title: 'France fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'French fine wines - a tradition of excellence that continues to inspire wine lovers worldwide. France produces more fine wine than any other country and, not surprisingly, has influenced wine producers from all over the world for centuries.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Bordeaux', src: '/wine-guide/france/bordeaux'},
                {report: 'Burgundy', src: '/wine-guide/france/burgundy'},
                {report: 'Champagne', src: '/wine-guide/france/champagne'},
                {report: 'Cognac', src: '/wine-guide/france/cognac'},
                {report: 'Jura', src: '/wine-guide/france/jura'},
                {report: 'Languedoc-Roussillon', src: '/wine-guide/france/languedoc-roussillon'},
                {report: 'Provence', src: '/wine-guide/france/provence'},
                {report: 'Rhone', src: '/wine-guide/france/rhone'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
            this.$router.push({path: this.localePath(a.src) });
        },
        goToPrev() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
